import { httpClient } from './http-client';
import type { ApiResponse } from './api.types';
import type { TipoCambio } from '@/modelos/TipoCambio';

export const tipoCambioService = {
  getHoy: (): Promise<ApiResponse<TipoCambio>> =>
    httpClient.get('/tipo-cambio/hoy'),

  getPorFecha: (fecha: string): Promise<ApiResponse<TipoCambio>> =>
    httpClient.get('/tipo-cambio', { fecha }),
};
